<template>
  <div>
    <div class="top-bar flex flex-col justify-between">
        <div class="account-title">{{ $t('account.promotions') }}</div>
        <div class="nav-bar ">
          <div
            class="bar-list"
            @click="currentTab = 'PromoteMonth'"
            :class="['bar-list', { is_active: currentTab === 'PromoteMonth' }]"
          >{{ $t('account.this_month_s_offers') }}</div>
          <div
            class="bar-list"
            @click="currentTab = 'PromoteMaster'"
            :class="['bar-list', { is_active: currentTab === 'PromoteMaster' }]"
          >{{ $t('account.mastercard_offers') }}</div>
          <div
            class="bar-list"
            @click="currentTab = 'PromotePromote'"
            :class="[
              'bar-list',
              { is_active: currentTab === 'PromotePromote' },
            ]"
          >{{ $t('account.promotions') }}</div>
      </div>
    </div>
    <div class="bottom">
      <keep-alive>
        <transition mode="out-in">
          <component v-bind:is="currentTab"></component>
        </transition>
      </keep-alive>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      currentTab: 'PromoteMonth'
    }
  },
  components: {
  }
}

</script>

<style scoped>
.v-enter,
.v-leave-to {
  opacity: 0;
  transform: translateX(150px);
}
.v-enter-active,
.v-leave-active {
  transition: all 0.3s ease;
}
.nav-bar {
  display: flex;
}
.bar-list {
  margin-right: 60px;
}
@media only screen and (max-width: 600px) {
  .bar-list {
    margin-right: 0;
    font-size: 14px;
  }
}
</style>
